import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import VersionHistoryItem from './VersionHistoryItem';
import VersionHistoryItemSkeleton from './VersionHistoryItemSkeleton';
import HorizontalRule from '../../componentLibrary/HorizontalRule';
import Button from '../../componentLibrary/Button';
import * as Styled from './styles';

// We need to calculate maxHeight and delay based on the number of items we have on the list
const animationListCapDelay = 1.5;
const maxHeightBasedOnListSize = (size) => 20 + size * 65;
const delayBasedOnListSize = (size) => {
    const delay = 0.5 + size * 0.025;
    return delay > animationListCapDelay ? animationListCapDelay : delay;
};

const VersionHistoryDateList = ({
    items,
    isFirstDate,
    isVersionHistoryLoaded,
    loadVersionHistoryItem,
    setSelectedItem,
    selectedItem,
}) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const { length } = items;
    const formatedDate = moment.unix(items[0].dateSaved).format('DD MMMM');

    return (
        <div>
            <Styled.VersionHistoryDateListHeader
                isFirstDate={isFirstDate}
                onClick={() => setIsCollapsed(!isCollapsed)}
                role="button"
                aria-label={`${isCollapsed ? 'Expand' : 'Collapse'} items from ${formatedDate}`}
            >
                <Styled.VersionHistoryDateListHeaderText>
                    {isVersionHistoryLoaded ? formatedDate : 'Loading...'}
                </Styled.VersionHistoryDateListHeaderText>
                <Button
                    label="Toggle List"
                    type="simple"
                    width={24}
                    icon={isCollapsed ? 'chevron-up' : 'chevron-down'}
                    color="#656566"
                    onClick={() => setIsCollapsed(!isCollapsed)}
                    hasTooltip={false}
                    hasHoverEffects={false}
                    iconSize={14}
                    iconPadding={0}
                    marginBottom={0}
                    keyDownPreventDefault
                />
            </Styled.VersionHistoryDateListHeader>
            <HorizontalRule styling={{ marginBottom: 2 }} />
            <Styled.VersionHistoryDateListContent
                isCollapsed={isCollapsed}
                maxHeight={maxHeightBasedOnListSize(length)}
                delay={delayBasedOnListSize(length)}
            >
                {items.map(({ dateSaved, firstName, lastName, email, versionID }, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Styled.VersionHistoryItemDiv key={`version-history-item-div-${index}`}>
                        {isVersionHistoryLoaded ? (
                            <VersionHistoryItem
                                dateSaved={dateSaved}
                                firstName={firstName}
                                lastName={lastName}
                                email={email}
                                isSelected={selectedItem === versionID}
                                isParentCollapsed={isCollapsed}
                                isLatestSaved={isFirstDate && index === 0}
                                selectVersionHistoryItem={() =>
                                    loadVersionHistoryItem(versionID) && setSelectedItem(versionID)
                                }
                                isVersionHistoryLoaded={isVersionHistoryLoaded}
                                key={`version-history-item-${dateSaved}`}
                            />
                        ) : (
                            <VersionHistoryItemSkeleton index={index} />
                        )}
                    </Styled.VersionHistoryItemDiv>
                ))}
            </Styled.VersionHistoryDateListContent>
        </div>
    );
};

VersionHistoryDateList.propTypes = {
    items: PropTypes.array.isRequired,
    isFirstDate: PropTypes.bool.isRequired,
    isVersionHistoryLoaded: PropTypes.bool.isRequired,
    loadVersionHistoryItem: PropTypes.func.isRequired,
    setSelectedItem: PropTypes.func.isRequired,
    selectedItem: PropTypes.string.isRequired,
};

export default VersionHistoryDateList;
